import { createRouter, createWebHistory } from 'vue-router';
import { FeedbackContainer } from '../pages/feedback';
import { GameContainer } from '../pages/game';
import { IndexContainer } from '../pages/index';
import { GameInfoContainer } from '../pages/info';
import { NotFoundContainer } from '../pages/not-found';
import { PlaylistsContainer } from '../pages/playlists';
import {
  GameCodeContainer,
  HostErrorContainer,
  HostRegistrationContainer,
  PlayerRegistrationContainer,
  SpotifySignInContainer,
} from '../pages/registration';
import { route } from '../shared/config/routes.ts';

export const routes = [
  { path: '/', name: route.index, component: IndexContainer },

  { path: '/spotify', name: route.spotifySignIn, component: SpotifySignInContainer },
  { path: '/host', name: route.hostRegister, component: HostRegistrationContainer },
  { path: '/host/error', name: route.hostError, component: HostErrorContainer },
  { path: '/code', name: route.gameCodeRegister, component: GameCodeContainer },
  {
    path: '/code/:gameCode(\\d+)',
    name: route.playerRegister,
    component: PlayerRegistrationContainer,
    props: true,
  },
  { path: '/game/:gameCode(\\d+)', name: route.game, component: GameContainer },
  { path: '/playlists', name: route.playlists, component: PlaylistsContainer },
  { path: '/feedback', name: route.feedback, component: FeedbackContainer },
  {
    path: '/info/:gameCode(\\d+)',
    name: route.gameInfo,
    component: GameInfoContainer,
    props: true,
  },

  { path: '/:unknownPath(.*)*', name: route.notFound, component: NotFoundContainer },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
